export default "__VITE_ASSET__usoTbcpt__"